import API from './api';

const recomputedIntervalTime = 2000;
export default {
  async getRecomputedData(url, params) {
    const firstFetch = await API.post(url, {
      first: true,
      ...params
    });
    const fetchResponse = await new Promise((resolve, reject) => {
      const recomputedDataInterval = setInterval(async () => {
        const dataResponse = await API.post(url, params).catch(err => {
          clearInterval(recomputedDataInterval);
          resolve({ error: true, err });
        });
        if (dataResponse.data && dataResponse.data.finished) {
          clearInterval(recomputedDataInterval);
          resolve(dataResponse);
        }
      }, recomputedIntervalTime);
    });
    return fetchResponse;
  },
};
